import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingService } from '../../../services/loading.service';
import { ToastService } from '../../../services/toast.service';
import { CompanyService } from '../../../services/company.service';

@Component({
  selector: 'app-new-company',
  templateUrl: './new-company.component.html',
  styleUrls: ['./new-company.component.scss']
})
export class NewCompanyComponent implements OnInit {
  companyForm!: FormGroup;
  companyId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private toastService: ToastService,
    private _loadingService: LoadingService,
    private _companyService: CompanyService
  ) {}

  ngOnInit(): void {
    this.initializeForm();
    this.checkForCompanyId();
  }

  initializeForm(): void {
    this.companyForm = this.fb.group({
      name: ['', [Validators.required, Validators.maxLength(100)]],
      typeDocument: [{ value: 'Nit', disabled: true }],
      documentId: ['', [Validators.required, Validators.maxLength(20)]],
      email: ['', [Validators.required, Validators.email, Validators.maxLength(100)]],
      phone: ['', [Validators.required, Validators.maxLength(20)]],
      addressLine1: ['', [Validators.required, Validators.maxLength(100)]],
      addressLine2: ['', Validators.maxLength(100)],
      city: ['', Validators.maxLength(50)],
      country: ['', Validators.maxLength(50)],
    });
  }

  checkForCompanyId(): void {
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.companyId = +params['id']; // Convert to number
        this.loadCompany(this.companyId);
      }
    });
  }

  loadCompany(id: number): void {
    this._loadingService.show();
    this._companyService.getById(id).subscribe({
      next: (response: any) => {
        this.companyForm.patchValue(response.data);
        this._loadingService.hide();
      },
      error: (err) => {
        console.error('Error al cargar la empresa:', err);
        this._loadingService.hide();
        this.toastService.showToast('error', 'Error al cargar la información de la empresa.');
        this.router.navigate(['/companies']); // Redirige si falla la carga
      }
    });
  }

  onSubmit(): void {
    if (this.companyForm.invalid) {
      this.companyForm.markAllAsTouched();
      return;
    }

    this._loadingService.show();

    if (this.companyId) {
      // Actualizar Empresa
      this._companyService.update(this.companyId, this.companyForm.value).subscribe({
        next: () => {
          this._loadingService.hide();
          this.handleSuccess('Empresa actualizada exitosamente');
        },
        error: (err) => {
          this._loadingService.hide();
          console.error('Error al actualizar la empresa:', err);
          const errorMessage = err?.error?.errorMessage || err?.error?.message || 'Error al actualizar la empresa';
          this.handleError(errorMessage);
        }
      });
    } else {
      // Crear Nueva Empresa
      this._companyService.insert(this.companyForm.value).subscribe({
        next: () => {
          this._loadingService.hide();
          this.handleSuccess('Empresa creada exitosamente');
        },
        error: (err) => {
          this._loadingService.hide();
          console.error('Error al crear la empresa:', err);
          const errorMessage = err?.error?.errorMessage || err?.error?.message || 'Error al crear la empresa';
          this.handleError(errorMessage);
        }
      });
    }
  }

  private handleSuccess(message: string): void {
    this.toastService.showToast('success', message);
    this.router.navigate(['/companies']);
  }

  private handleError(message: string): void {
    this.toastService.showToast('error', message);
  }

  goBack(): void {
    this.router.navigate(['/companies']);
  }
}
